import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/authContext';
import { API_URL } from '../lib/config';
import './AdminPage.css'; // 기존 관리자 페이지 스타일 재사용

function NoticeAdminPage() {
    const [notices, setNotices] = useState([]);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();
    const { currentUser } = useAuth();

    // 공지사항 목록 불러오기
    const fetchNotices = async () => {
        try {
            // 사용자용 공지 목록 API를 그대로 사용
            const response = await fetch(`${API_URL}/api/notices`);
            const data = await response.json();
            if (response.ok) {
                setNotices(data);
            }
        } catch (error) {
            console.error("공지사항 목록 로딩 실패:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchNotices();
    }, []);

    const handleDeleteNotice = async (noticeId) => {
        if (window.confirm("정말로 이 공지사항을 삭제하시겠습니까?")) {
            try {
                const idToken = await currentUser.getIdToken();
                const response = await fetch(`${API_URL}/api/admin/notices/${noticeId}`, {
                    method: 'DELETE',
                    headers: { 'Authorization': `Bearer ${idToken}` }
                });

                if (!response.ok) {
                    throw new Error('삭제에 실패했습니다.');
                }
                alert('공지사항이 삭제되었습니다.');
                fetchNotices(); // 목록 새로고침
            } catch (error) {
                alert(`오류: ${error.message}`);
            }
        }
    };

    if (loading) return <div className="admin-container">로딩 중...</div>;

    return (
        <div className="admin-container">
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <h1>공지사항 관리 ({notices.length}개)</h1>
                <button className="admin-add-button" onClick={() => navigate('/admin/notices/new')}>새 공지 작성</button>
            </div>
            <table className="admin-table">
                <thead>
                    <tr>
                        <th>제목</th>
                        <th>작성일</th>
                        <th>작업</th>
                    </tr>
                </thead>
                <tbody>
                    {notices.map(notice => (
                        <tr key={notice._id}>
                            <td>{notice.title}</td>
                            <td>{new Date(notice.createdAt).toLocaleString()}</td>
                            <td>
                                <button onClick={() => navigate(`/admin/notices/edit/${notice._id}`)} style={{ marginRight: '10px' }}>수정</button>
                                <button onClick={() => handleDeleteNotice(notice._id)} style={{ backgroundColor: '#e53e3e' }}>삭제</button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}

export default NoticeAdminPage;